/**
 * Add stylesheet to head.
 *
 * @param {string} url
 * @param {string} handle
 * @param {bool}   before
 */
window.pdg_add_css = function( url, before ) {

    if ( typeof handle === 'undefined' ) {
        handle = false;
    }

    if ( typeof before === 'undefined' ) {
        before = false;
    }

    var head = document.head;
    var link = document.createElement( 'link' );
  
    link.rel  = 'stylesheet';
    link.href = url;
  
    if ( before ) {
        $( 'head' ).prepend( link );
    } else {
        head.appendChild( link );
    }

}

/**
 * Add script to document.
 * 
 * @param {string} url
 * @param {string} handle
 * @param {bool}   retrn
 */
window.pdg_add_js = function( url, retrn ) {

    if ( typeof retrn === 'undefined' ) {
        retrn = false;
    }

    var script = document.createElement( 'script' );

    script.setAttribute( 'src', url );
    
    document.body.appendChild( script );

    if ( retrn ) {
        return script;
    }

}

/**
 * Load assets when user interacts with document.
 */
var load_js_index = 0;

function load_js() {

    if ( pdg_late_load['js'].length == 0 ) {
        return;
    }

    if ( load_js_index < pdg_late_load['js'].length ) {
        var script_ref = pdg_late_load['js'][load_js_index];
        var script     = pdg_add_js( script_ref, true );

        script.onload = function() {
            load_js_index++;
            load_js();
        };
    } else {
        var event;

        if ( typeof( Event ) === 'function' ) {
            event = new Event( 'DOMContentLoaded', {
                bubbles: true,
                cancelable: true
            } );
        } else {
            event = document.createEvent( 'Event' );
            event.initEvent( 'DOMContentLoaded', true, true );
        }

        window.document.dispatchEvent( event );
    }
}

function load_css() {

    if ( pdg_late_load['css'].length == 0 ) {
        return;
    }

    for ( var i = 0; i < pdg_late_load['css'].length; i++ ) {
        $( '<link rel="preload" href="' + pdg_late_load['css'][i] + '" as="style">' ).appendTo( 'head' );

        pdg_add_css( pdg_late_load['css'][i], true );
    }

}


/**
 * Late load scripts and styles.
 */
if ( typeof pdg_late_load !== 'undefined' ) {
    var f_late_loaded = false;

    $( document ).on( 'click mousemove touchstart scroll', function() {
        if ( ! f_late_loaded ) {
            load_js();
            load_css();

            f_late_loaded = true;
        }
    } );
}



$( document ).ready( function() {

    var $d = $( document );
    var $b = $( 'body' );

    /**
     * Force late load scripts and styles to be loaded instantly on certain pages.
     */
    if ( $( window ).width() <= 1099 && ! f_late_loaded ) {
        if ( $( '[data-form="login"]' ).length ) {
            load_js();
            load_css();

            f_late_loaded = true;
        }
    }

    /**
     * Lazy load images.
     */
    $( '.lazy' ).lazy();


    /**
     * Add body class when document is scrolled.
     */
    function body_scrolled_class() {
        if ( $d.scrollTop() > 24 ) {
            $b.addClass( 'scrolled' );
        } else {
            $b.removeClass( 'scrolled' );
        }
    }

    body_scrolled_class();
    $d.on( 'scroll', body_scrolled_class );

    if ( $( window ).width() >= 768 ) {
        $d.on( 'scroll', function() {
            $b.removeClass( 'lang-picker-active' );
        } );
    }


    /**
     * Burger click.
     */
    $d.on( 'click', '.js-burger', function() {
        $b.toggleClass( 'nav-open' );
    } );


    /**
     * Video playback.
     */
    $d.on( 'click', '.js-video', function() {

        var $wrap  = $( this );
        var type   = this.dataset.type;
        var src    = this.dataset.src;
        var width  = $wrap.width();
        var height = $wrap.outerHeight();

        $wrap.addClass( 'video--init' );

        if ( type == 'youtube' ) {
            $wrap.append( '<iframe/>' );

            var iframe = $( 'iframe', $wrap )[0];
    
            iframe.width           = width;
            iframe.height          = height;
            iframe.frameborder     = 0;
            iframe.allow           = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe.allowfullscreen = true;
            iframe.src             = 'https://www.youtube.com/embed/' + src + '?autoplay=1';
        } else if ( type == 'local' ) {
            $wrap.append( '<video><source src="' + src + '"></video>' );

            var video = $( 'video', $wrap )[0];

            video.width    = width;
            video.height   = height;
            video.controls = true;
            video.autoplay = true;
        }

    } );

    /**
     * Sub menu toggle on mobile views.
     */
    $d.on( 'click', '.js-toggle-sub-menu', function( e ) {
        e.preventDefault();

        var $li = $( this ).closest( 'li' );

        if ( ! $li.hasClass( 'open' ) ) {
            $li.addClass( 'open' );
        } else {
            $li.removeClass( 'open' );
        }
    } );

    /**
     * Prepare tables.
     */
    $( '.table, .editor > table' ).wrap( '<div class="table-wrap"/>' );

    /**
     * User actions.
     */
    if ( $( window ).width() <= 1099 ) {
        $d.on( 'click', '.user-actions__item > a', function( e ) {
            e.preventDefault();

            $( this ).closest( '.user-actions__item' ).toggleClass( 'open' );

            return false;
        } );

        $d.on( 'click', '.user-actions__item', function( e ) {
            e.stopPropagation();
        } );

        $d.on( 'click', function() {
            $( '.user-actions__item' ).removeClass( 'open' );
        } );
    }

} );

$( window ).on( 'load', function() {

    /**
     * Hide language picker.
     */
    var $lang_picker = $( '.lang-picker' );

    setTimeout( function() {
        $lang_picker.css( 'margin-top', '-' + ( $lang_picker.outerHeight() ) + 'px' ).addClass( 'lang-picker--init' );
    }, 100 );

} );